import BaseModel from '../base/BaseModel.model';
export default class ProposalCancelled extends BaseModel {
    public description?: string;
    public documentId?: number;
    public document: any;
    public isCancelled:boolean;
    init() {
        this.description = '';
        this.document = null;
        this.documentId = 0;
        this.isCancelled = null;
    }
}